import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Tree } from "../components/Tree";

import "./styles.less";

export const TreeItem = (props) => {
  let { t } = useTranslation();
  const { data, isRoot, currentKey, setCurrentKey } = props;
  const [isActive, setActive] = useState(false);

  return (
    <div className="authing-menu-tree-item">
      {!data.children && (
        <a
          href={data.url}
          className={
            isRoot
              ? "tree-item tree-root top"
              : data.rank === 2
              ? "tree-item bottom indent"
              : "tree-item bottom"
          }
        >
          <h4>{data.title}</h4>
        </a>
      )}
      {data.children && (
        <div>
          <div
            className={isRoot ? "tree-item tree-root" : "tree-item"}
            onClick={() => {
              setActive((state) => !state);
              setCurrentKey(data.key);
              window.scrollTo();
            }}
          >
            <h4>{data.title}</h4>
            <span
              className={
                currentKey === data.key && isActive
                  ? "arrow-footer-outline footer-collapse-expaned"
                  : "arrow-footer-outline"
              }
            ></span>
          </div>
          <div
            className={
              currentKey === data.key && isActive
                ? "tree-children tree-children-active"
                : "tree-children"
            }
          >
            {data.url && (
              <a href={data.url} className="tree-title-overview">
                {data.title}
                {t("common.nav.nav-overview")}
              </a>
            )}
            {data.children.map((item) => {
              return (
                <div className="tree-children-block">
                  <div className="tree-item-type">
                    <i className={`icon authing-icon ${item.icon}`}></i>
                    <span>{item.type}</span>
                  </div>
                  <div className="tree-sub-item-warp">
                    {item.submenus?.map((subTitle) => (
                      <div className="tree-sub-item">
                        {subTitle.imgCustomerIcon && (
                          <div className="tree-sub-icon">
                            <img
                              src={`//files.authing.co/authing-website/${subTitle.imgCustomerIcon}`}
                              alt="authing"
                            />
                          </div>
                        )}
                        {subTitle.urlType && subTitle.urlType === "outlink" ? (
                          <a className="tree-sub-title" href={subTitle.url}>
                            {subTitle.title}
                          </a>
                        ) : (
                          <Link className="tree-sub-title" to={subTitle.url}>
                            {subTitle.title}
                          </Link>
                        )}
                        {subTitle.tag && (
                          <i
                            className="icon authing-icon authing-hot2"
                            style={{
                              color: "#E63333",
                              fontSize: 15,
                              marginLeft: 4,
                            }}
                          ></i>
                        )}
                        {subTitle.job && (
                          <span className="jobTag">{subTitle.job}</span>
                        )}
                        {subTitle.link && (
                          <a className="tree-sub-link" href={subTitle.url}>
                            {subTitle.link}
                          </a>
                        )}
                      </div>
                    ))}
                  </div>
                  {item.productExtra && (
                    <div className="tree-product-extra">
                      {item.productExtra.map((extraItem) => (
                        <div className="tree-extra-item">
                          <div className="tree-extra-item-icon">
                            <img src={extraItem.icon} alt="" />
                          </div>
                          <a
                            className="tree-extra-item-title"
                            href={extraItem.url}
                          >
                            {extraItem.title}
                          </a>
                        </div>
                      ))}
                    </div>
                  )}
                  {item.solutionExtra && (
                    <div className="tree-solution-extra">
                      <div className="title">
                        <i className="icon authing-icon authing-apps-2-line"></i>
                        {t("common.nav.nav-type-application")}
                      </div>
                      <div className="description">
                        {t("common.nav.nav-solution-extra-subtitle")}
                      </div>
                      <div className="solution-img">
                        <img
                          src="//files.authing.co/authing-website/nav-solution-img-new.png"
                          alt=""
                        />
                      </div>
                    </div>
                  )}
                  {item.aboutExtra && (
                    <div className="tree-about-extra">
                      <div className="title">
                        <i className="icon authing-icon authing-open-arm-line"></i>
                        {item.aboutExtra.title}
                      </div>
                      <div className="about-img">
                        <img
                          src={t("common.nav.nav-type-APN-img")}
                          alt="authing"
                        />
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
            {/* <Tree data={data.children} isRoot={false} /> */}
          </div>
        </div>
      )}
    </div>
  );
};
